import {
  IApiResponse,
  IPainSubmissionData,
  ISymptomsCategoryResponse,
  ISymptomsPainsFilterParams,
  ISymptomsSubmissionData,
  ISymptonsResponse,
  IPatientSymptomResponse,
  IPatientPainsResponse
} from 'types'
import { request } from 'services/base'
import {
  BASE_PATIENT_PAIN_ENDPOINT,
  PATIENT_PAINS_ENDPOINT,
  PATIENT_SYMPTOMS_BATCH_ENDPOINT,
  PATIENT_SYMPTOMS_ENDPOINT,
  SYMPTOMS_BY_CATEGORY_ENDPOINT,
  SYMPTOMS_CATEGORY_ENDPOINT
} from './CONSTANTS'

export const getPatientSymptoms = async (
  patientId?: string,
  params?: ISymptomsPainsFilterParams
): Promise<IApiResponse<IPatientSymptomResponse[]>> =>
  await request({
    url: PATIENT_SYMPTOMS_ENDPOINT(patientId),
    method: 'get',
    params
  })

export const getPatientPains = async (
  patientId?: string,
  params?: ISymptomsPainsFilterParams
): Promise<IApiResponse<IPatientPainsResponse[]>> =>
  await request({
    url: PATIENT_PAINS_ENDPOINT(patientId),
    method: 'get',
    params
  })

export const getSymptomsCategory = async (): Promise<
  IApiResponse<ISymptomsCategoryResponse[]>
> =>
  await request({
    url: SYMPTOMS_CATEGORY_ENDPOINT,
    method: 'get'
  })

export const getSymptomsByCategory = async (
  categoryId: string
): Promise<IApiResponse<ISymptonsResponse[]>> =>
  await request({
    url: SYMPTOMS_BY_CATEGORY_ENDPOINT(categoryId),
    method: 'get'
  })

export const addPatientSymptoms = async (
  data: ISymptomsSubmissionData[]
): Promise<IApiResponse<any>> =>
  await request({
    url: PATIENT_SYMPTOMS_BATCH_ENDPOINT,
    method: 'post',
    data
  })

export const addPatientPains = async (
  data: IPainSubmissionData
): Promise<IApiResponse<any>> =>
  await request({
    url: BASE_PATIENT_PAIN_ENDPOINT,
    method: 'post',
    data
  })
